import { render, staticRenderFns } from "./SpadL.vue?vue&type=template&id=902a834e"
import script from "./SpadL.vue?vue&type=script&lang=js"
export * from "./SpadL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports